(function () {
  'use strict';

  /* @ngdoc object
   * @name cashbook
   * @description
   *
   */
  angular
    .module('vcfinance.cashbook', [
      'ui.router'
    ]);
}());
